"use client"

import { Menu, User } from "lucide-react"
import { useTranslations } from "next-intl"

import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import { Link, usePathname } from "@/i18n/routing"
import { ROUTES } from "@/routes"

import { LanguageSelector } from "../LanguageSelector"
import PopoverCart from "../PopverCart"
import SpectraLogo from "../shared/SpectraLogo"
import { useIsMobile } from "@/hooks/useGlobalStore"

export default function NonAuthHeader() {
  const isMobile = useIsMobile()
  const t = useTranslations("common")
  const pathname = usePathname()

  const isInMarketplace = pathname.includes(ROUTES.explore)
  const isInMerchant = pathname.includes(ROUTES.merchant)

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 md:gap-4">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="translate-y-0.5">
              <Menu className="size-5" />
            </Button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="animate-slide-in-from-left data-[state=closed]:animate-slide-out-to-left"
          >
            <SheetHeader>
              <SheetTitle>
                <SpectraLogo className="justify-center font-normal" />
              </SheetTitle>
            </SheetHeader>
            <div className="mt-8 flex flex-col gap-4">
              <div className="space-y-4">
                <h3 className="text-sm font-medium">{t("nonAuthHeader.merchants")}</h3>
                <div className="flex flex-col gap-2">
                  <Button asChild>
                    <Link href={ROUTES.loginMerchant}>{t("auth.login.title")}</Link>
                  </Button>
                  <Button variant="outline" asChild>
                    <Link href={ROUTES.signupMerchant}>{t("auth.signup.signUp")}</Link>
                  </Button>
                </div>
              </div>
            </div>
          </SheetContent>
        </Sheet>
        <SpectraLogo />
      </div>
      <div className="flex items-center gap-1">
        {isMobile ? (
          <Popover>
            <PopoverTrigger asChild>
              <Button variant="ghost" className="mr-2 size-4 p-4 hover:bg-transparent">
                <div className="flex animate-color-cycle flex-col items-center gap-2">
                  <User className="size-5 translate-y-2" />
                  <span className="text-[10px] font-medium">{t("auth.signup_icon")}</span>
                </div>
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-48">
              <div className="flex flex-col gap-2">
                <Button asChild className="justify-center">
                  <Link href={ROUTES.loginCustomer}>{t("auth.login.title")}</Link>
                </Button>
                <Button asChild className="justify-center">
                  <Link href={ROUTES.signupCustomer}>{t("auth.signup.signUp")}</Link>
                </Button>
              </div>
            </PopoverContent>
          </Popover>
        ) : (
          <>
            <Button variant="ghost" asChild>
              <Link href={ROUTES.loginCustomer}>{t("auth.login.title")}</Link>
            </Button>
            <Button asChild>
              <Link href={ROUTES.signupCustomer}>{t("auth.signup.signUp")}</Link>
            </Button>
          </>
        )}
        {(isInMarketplace || isInMerchant) && <PopoverCart ongoingOrder={null} />}
        <LanguageSelector />
      </div>
    </div>
  )
}
